import { SuiteService } from './src/services/suite.services';

export type { IdEntity, IdLabelEntity, StringIdLabelEntity } from './src/services/suite.interfaces';
export type { Evento } from './src/services/suite.interfaces';
export type { Acreditado, TipoAcreditado, EstadoAcreditado, Invitacion, OrigenAcreditado, TipoArchivo, ArchivoAcreditado, Campo  } from './src/services/suite.interfaces';

export const suiteService = new SuiteService();

export default suiteService;
